import React, { useState } from "react";
import contact_logos from "../data/contact";
import profile from "../data/profile";

const ContactInfo = () => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-8 border border-gray-100">
      <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
        Comment me contacter ?
      </h3>

      <div className="space-y-6">
        {/* Email principal */}
        <a
          href="mailto:lapertfabien@gmail.com"
          className="group flex items-center p-4 rounded-lg border border-gray-200 transition-colors duration-200"
        >
          <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 group-hover:bg-primary group-hover:text-white transition-colors">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
          </div>
          <div className="flex-1">
            <h4 className="font-semibold text-gray-900 group-hover:text-primary transition-colors">
              Email professionnel
            </h4>
            <p className="text-gray-600 text-sm">lapertfabien@gmail.com</p>
          </div>
          <svg
            className="w-5 h-5 text-gray-400 group-hover:text-primary transition-colors"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
        </a>

        {/* Réponse rapide */}
        <div className="text-center py-4">
          <p className="text-sm text-gray-500 mb-3">
            Temps de réponse habituel
          </p>
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-green-100 text-green-800 text-sm font-medium">
            <span className="w-2 h-2 bg-green-500 rounded-full mr-2 animate-pulse"></span>
            Moins de 24h
          </div>
        </div>

        {/* Call to action */}
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-6 text-center border border-blue-100">
          <h4 className="font-semibold text-gray-900 mb-2">Une question ?</h4>
          <p className="text-gray-600 text-sm mb-4">
            N'hésitez pas à m'écrire pour discuter de vos projets ou pour toute
            opportunité professionnelle.
          </p>
          <a
            href="mailto:lapertfabien@gmail.com?subject=Contact depuis le portfolio"
            className="ui-btn inline-flex items-center px-4 py-2 bg-gradient-to-r from-primary to-blue-600 text-white font-medium rounded-md transition-colors duration-200 shadow-sm text-sm"
          >
            <svg
              className="mr-2 w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
              />
            </svg>
            Envoyer un email
          </a>
        </div>
      </div>
    </div>
  );
};

const ContactCard = ({ contact }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      href={contact.href}
      target="_blank"
      rel="noopener noreferrer"
      className="group block"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="bg-white rounded-lg p-8 shadow-sm border border-gray-100 transition-all duration-200 text-center h-full flex flex-col">
        <div className="relative mb-6 flex-shrink-0">
          <div className="w-20 h-20 mx-auto rounded-full bg-gradient-to-br from-primary/10 to-blue-600/10 flex items-center justify-center transition-transform duration-200">
            <img
              className="w-12 h-12 object-contain filter transition-transform duration-200"
              src={`/contact/${contact.logo}`}
              alt={contact.name}
            />
          </div>
          {isHovered && (
            <div className="absolute -top-2 -right-2 w-6 h-6 bg-primary rounded-full flex items-center justify-center animate-bounce">
              <svg
                className="w-3 h-3 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </div>
          )}
        </div>
        <div className="flex-grow flex flex-col justify-center">
          <h3 className="text-xl font-bold text-gray-900 transition-colors">
            {contact.name}
          </h3>
          <p className="text-gray-600 mt-2 transition-colors">
            {contact.name === "Linkedin" &&
              "Connectons-nous professionnellement"}
            {contact.name === "Github" && "Découvrez mes projets"}
          </p>
        </div>
      </div>
    </a>
  );
};

const Contact = () => {
  return (
    <div
      className="w-full pt-24 lg:pt-32 relative overflow-hidden"
      id="contact"
    >
      {/* Arrière-plan animé avec bulles décoratives */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-indigo-50"></div>
      <div className="absolute top-32 left-10 w-32 h-32 bg-primary/5 rounded-full animate-pulse"></div>
      <div
        className="absolute top-40 right-20 w-24 h-24 bg-blue-500/5 rounded-full animate-bounce"
        style={{ animationDelay: "1s" }}
      ></div>
      <div
        className="absolute bottom-40 left-20 w-40 h-40 bg-indigo-500/5 rounded-full animate-pulse"
        style={{ animationDelay: "2s" }}
      ></div>

      <div className="relative lg:mx-auto lg:max-w-7xl lg:w-full lg:pb-20">
        <div className="px-4 lg:px-8">
          {/* Header */}
          <div className="text-center mb-16">
            <h1 className="lg:tracking-tight font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-primary via-blue-600 to-indigo-600 lg:text-6xl text-4xl mb-6">
              Contactez-moi
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Une question, un projet ou simplement envie d'échanger ? Je serais
              ravi de discuter avec vous !
            </p>
          </div>

          {/* Contact Info */}
          <div className="grid lg:grid-cols-2 gap-12 mb-16">
            <div>
              <div className="bg-white rounded-lg shadow-sm p-8 border border-gray-100">
                <h2 className="text-2xl font-bold text-gray-900 mb-8">
                  À propos de moi
                </h2>

                <div className="space-y-6">
                  <div className="flex items-center p-4 rounded-xl border border-gray-100 bg-gray-50">
                    <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4">
                      <svg
                        className="w-6 h-6 text-green-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">
                        Localisation
                      </h3>
                      <p className="text-gray-600">{profile.location}</p>
                    </div>
                  </div>

                  <div className="flex items-center p-4 rounded-xl border border-gray-100 bg-gray-50">
                    <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4">
                      <svg
                        className="w-6 h-6 text-purple-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">
                        Disponibilité
                      </h3>
                      <p className="text-gray-600">
                        {profile.availability.status}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Réseaux sociaux */}
                <div className="mt-8">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">
                    Retrouvez-moi sur
                  </h3>
                  <div className="grid grid-cols-2 gap-4 items-stretch">
                    {contact_logos.map((contact, index) => (
                      <ContactCard key={index} contact={contact} />
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Direct */}
            <div>
              <ContactInfo />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
